import React from 'react';
import styled from 'styled-components';
import { Field, Form, Formik } from 'formik';
import { sha256 } from 'js-sha256';
import { TextField } from '../forms';
import { DarkBlueOutlineButton } from '../buttons';
import { rtypeN16r, rtypeT38sb } from '../../styles/typography/presets';


const Title = styled.div`
  ${rtypeT38sb};
  margin-bottom: 15px;
`;

const Password = styled(TextField)`

`;

const RememberMe = styled.div`
  display: flex;
  align-items: center;
  label {
    ${rtypeN16r};
    padding-left: 5px;
  }
`;

const SubmitButton = styled(DarkBlueOutlineButton)`

`;

const LoginForm = styled(Form)`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  max-width: 400px;
  margin: 0 auto;
  padding: 120px 0;
  ${Title} {
    width: 100%;
  }
  ${Password} {
    flex-grow: 1;
    margin-right: 15px;
  }
  ${SubmitButton} {
  }
  ${RememberMe} {
    width: 100%;
    margin-top: 10px;
  }
`;

const Container = styled.div`
`;


class PrivateContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locked: true,
    };
  }

  componentDidMount() {
    const token = window.localStorage.getItem('korus_lounge.token');
    if (token === sha256(this.props.password)) {
      this.setState({
        locked: false
      });
    }
  }

  authenticate = ({ password, rememberMe }) => {
    if (password === this.props.password) {
      this.setState({
        locked: false,
      });
      if (rememberMe) {
        window.localStorage.setItem('korus_lounge.token', sha256(password));
      }
    }
  };

  render() {
    return (
      <Container>
        {this.state.locked && (
          <Formik
            onSubmit={this.authenticate}
            initialValues={{
              password: '',
              rememberMe: false,
            }}
          >
            {() => (
              <LoginForm>
                <Title>Login to view content</Title>
                <Password name={'password'} type={'password'} placeholder={'Password'}/>
                <SubmitButton type={'submit'}>Submit</SubmitButton>
                <RememberMe>
                  <Field type={'checkbox'} id={'rememberMe'} name={'rememberMe'}/>
                  <label htmlFor={'rememberMe'}>Remember me</label>
                </RememberMe>
              </LoginForm>
            )}
          </Formik>
        )}
        {!this.state.locked && this.props.children}
      </Container>
    );
  }
}

export default PrivateContent;